var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadgeWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 65,
    viewBox: "0 0 44 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 45V0H40V45C40 56.0457 31.0457 65 20 65C8.95431 65 0 56.0457 0 45Z",
    fill: "#2E2E2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 5V0L44 5H40Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2051 36.5499C26.615 30.9998 19.2852 29.3498 13.6009 32.7998C8.06614 36.2499 6.27108 43.7499 9.86119 49.3L10.1604 49.75L8.96366 54.25L13.4513 53.05L13.9001 53.35C15.8447 54.4 17.9389 55 20.0332 55C22.277 55 24.5208 54.4 26.4654 53.2C32.0002 49.6 33.6456 42.2499 30.2051 36.5499ZM27.0638 48.0999C26.4654 49 25.7175 49.6 24.6704 49.75C24.072 49.75 23.3241 50.05 20.3323 48.85C17.7893 47.6499 15.6951 45.6999 14.1992 43.4499C13.3017 42.3999 12.8529 41.0499 12.7034 39.6999C12.7034 38.4999 13.1521 37.4499 13.9001 36.6999C14.1992 36.3999 14.4984 36.2499 14.7976 36.2499H15.5455C15.8447 36.2499 16.1439 36.2499 16.2935 36.8499C16.5926 37.5999 17.3406 39.3999 17.3406 39.5499C17.4902 39.6999 17.4902 39.9999 17.3406 40.1499C17.4902 40.4499 17.3406 40.7499 17.191 40.8999C17.0414 41.0499 16.8918 41.3499 16.7422 41.4999C16.4431 41.6499 16.2935 41.9499 16.4431 42.2499C17.0414 43.1499 17.7893 44.0499 18.5373 44.7999C19.4348 45.5499 20.3323 46.1499 21.3795 46.5999C21.6786 46.7499 21.9778 46.7499 22.1274 46.4499C22.277 46.1499 23.0249 45.3999 23.3241 45.0999C23.6233 44.7999 23.7729 44.7999 24.072 44.9499L26.4654 46.1499C26.7646 46.2999 27.0638 46.4499 27.2134 46.5999C27.363 47.0499 27.363 47.6499 27.0638 48.0999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeWhatsapp);
export default __webpack_public_path__ + "static/media/badge-whatsapp.3cec8081eee030799934e361f7dca6eb.svg";
export { ForwardRef as ReactComponent };